module.exports = __webpack_public_path__ + "img/ic_room_marketing_left_img1.340235be.png";